// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as OrderRoutes from "../../app/Order/OrderRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderNameTableCell(props) {
  let id = props.id;
  let shopName = props.shopName;
  let orderPageRoute = id !== undefined ? OrderRoutes.baseRoute + "/" + id : OrderRoutes.baseRoute;
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextLink.make, {
          text: I18n.t(props.value),
          to: {
            TAG: "Route",
            _0: orderPageRoute
          }
        }),
        shopName !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: shopName,
            variation: "normal",
            size: "xxsmall"
          }) : null
      ],
      space: Stdlib_Option.isSome(shopName) ? "xxsmall" : "none"
    }),
    spaceY: "xsmall"
  });
}

let make = React.memo(OrderNameTableCell);

export {
  make,
}
/* make Not a pure module */
